// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-aa89b3c6]{color:#0085ff}.card[data-v-aa89b3c6]{background:#fff;z-index:9}.home-phone[data-v-aa89b3c6]{top:440px}@media screen and (max-width:840px){.home-phone[data-v-aa89b3c6]{top:460px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
